import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { Icon } from '../Icon'
import { Typography } from '../Typography'

export const TOURNAMENT_SIZE_LIST = ['4', '8', '10', '12', '16', '20', '24', '32', '48', '64', '128']

export function TournamentSizeDropdown({
  value,
  onChange,
  error,
  label = 'BRACKET SIZE',
  sublabel = '(Number of tournament spots)',
}: {
  value?: string
  onChange: (val: string) => void
  error?: string // Add the error prop
  label?: string
  sublabel?: string
}) {
  const selectedFormat = TOURNAMENT_SIZE_LIST?.find((size) => size === value)

  return (
    <div className="w-full">
      <div className="mb-2">
        <Typography variant="caption-xs" className="text-dark-typo-gray">
          {label}
        </Typography>
        <Typography variant="caption-xs" className="text-dark-typo-gray opacity-70">
          {sublabel}
        </Typography>
      </div>
      <Menu as="div" className="relative inline-block text-left w-full">
        <div>
          <Menu.Button
            className={`flex items-center justify-between w-full bg-dark-card border-2 ${
              error ? 'border-red-500' : selectedFormat ? 'border-green' : 'border-dark-border'
            } hover:border-green rounded-lg px-3 py-2 text-sm font-medium transition-colors`}
          >
            <Typography
              fontWeight="semibold"
              className={selectedFormat ? 'text-white' : 'text-dark-typo-gray'}
            >
              {selectedFormat ? `${selectedFormat} Teams` : 'Select bracket size...'}
            </Typography>
            <Icon size={18} color={selectedFormat ? 'primary' : 'secondary'} name="chevronDown" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="mt-1 border border-dark-border absolute right-0 w-full bg-dark-card origin-top-right divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
            <div className="px-1 py-1">
              {TOURNAMENT_SIZE_LIST &&
                TOURNAMENT_SIZE_LIST.map((size) => (
                  <Menu.Item key={size}>
                    {({ active }) => (
                      <button
                        type="button"
                        className={`${
                          active
                            ? 'bg-violet-500 text-white bg-dark-gray-primary'
                            : 'border-dark-typo-gray'
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                        onClick={() => {
                          onChange(size)
                        }}
                      >
                        {size} Teams
                      </button>
                    )}
                  </Menu.Item>
                ))}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
      {error && (
        <Typography variant="caption-xs" className="text-red mt-1">
          {error}
        </Typography>
      )}
    </div>
  )
}
